import $ from 'jquery'
import { transXSS } from '../../common/js/util'

function init(config) {
  let container = config.container,
    searchPattern = config.searchUrl,
    searchInput = container.find('.J-search-input'),
    searchBtn = container.find('.J-search-btn')

  searchBtn.on('click', clickCB)
  searchInput.on('keydown', function (e) { // enter
    if (e.keyCode === 13) {
      $(searchBtn[0]).trigger('click');
      return false;
    }
  })

  /**
   * click 回掉函数
   */
  function clickCB(e) {
    let searchStr = transXSS(searchInput.val().trim())
    if (searchStr.length > 0) {
      let searchPath = searchPattern + searchStr
      window.location.href = searchPath
    } else {
      e.preventDefault()
      return
    }
  }
}



export default {
  init: function (config) {
    init(config);
  }
}


// WEBPACK FOOTER //
// ./modules/logo-input/js/basic-search.js